import { CommonModule } from '@angular/common';
import {
    Component,
    OnInit,
    OnDestroy,
    ViewChild,
    ElementRef,
    ChangeDetectorRef,
    inject,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule, RouterOutlet } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { NavComponent } from '../nav/nav.component';
import { filter, Subscription } from 'rxjs';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SidenavComponent } from '../sidenav/sidenav.component';
import { ResponsiveService } from '../../shared/services/responsive.service';

@Component({
    selector: 'app-dashboard',
    standalone: true,
    imports: [
        RouterModule,
        CommonModule,
        RouterOutlet,
        NavComponent,
        MatDialogModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        TranslateModule,
        SidenavComponent,
    ],
    templateUrl: './dashboard.component.html',
    styleUrl: './dashboard.component.sass',
})
export class DashboardComponent implements OnInit, OnDestroy {
    private router = inject(Router);
    private route = inject(ActivatedRoute);
    private translate = inject(TranslateService);
    protected responsive = inject(ResponsiveService);
    private cdr = inject(ChangeDetectorRef);

    @ViewChild('scrollContainer') scrollContainer!: ElementRef;
    private routerSub!: Subscription;

    isCollapsed = true;

    constructor() {
        const savedLang = localStorage.getItem('lang') || 'en';
        this.translate.setDefaultLang('en');
        this.translate.use(savedLang);
    }

    ngOnInit() {
        // Reset scroll position on route change
        this.routerSub = this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe(() => {
                if (this.scrollContainer) {
                    this.scrollContainer.nativeElement.scrollTo(0, 0);
                }
            });

        // Force sidebar to be expanded on desktop screens
        this.responsive.screenClass.subscribe((size) => {
            if (size !== 'phone') {
                this.isCollapsed = true;
                this.cdr.detectChanges();
            }
        });
    }

    ngOnDestroy() {
        if (this.routerSub) {
            this.routerSub.unsubscribe();
        }
    }
}
